import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

import VerifiedRoundedIcon from "@mui/icons-material/VerifiedRounded";
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import SecurityRoundedIcon from "@mui/icons-material/SecurityRounded";
import PaymentsRoundedIcon from "@mui/icons-material/PaymentsRounded";

import "./Highlights.css";

const items = [
  {
    icon: <VerifiedRoundedIcon />,
    title: "Approved Project",
    desc: "Clear documentation with a secure buying process.",
  },
  {
    icon: <LocationOnRoundedIcon />,
    title: "Prime Location",
    desc: "Connected to key roads, business hubs, and essentials.",
  },
  {
    icon: <SecurityRoundedIcon />,
    title: "Smart Security",
    desc: "24/7 surveillance, controlled access, and safety focus.",
  },
  {
    icon: <PaymentsRoundedIcon />,
    title: "Flexible Payment",
    desc: "Installments designed to make ownership realistic.",
  },
];

const Highlights = () => {
  const { ref, inView } = useInView({ threshold: 0.2, triggerOnce: true });

  return (
    <section className="highlights" ref={ref}>
      <div className="highlights__container">
        <motion.div
          className="highlights__grid"
          initial={{ opacity: 0, y: 16 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7 }}
        >
          {items.map((item, idx) => (
            <motion.div
              key={idx}
              className="highlights__card"
              initial={{ opacity: 0, y: 16 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.08 * idx }}
            >
              <div className="highlights__icon">{item.icon}</div>
              <div className="highlights__text">
                <h3 className="highlights__title">{item.title}</h3>
                <p className="highlights__desc">{item.desc}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Highlights;
